<template>
  <div v-if="tags" class="d--inline">
    <dara-tag
      v-for="tag in tags.slice(0,5)"
      :key="tag.id"
      :label="tag.name"
      :to="getTagLink(tag)"
      size="sm"
      type="info"
      class="mr--md" />
    <dara-tag
      v-if="tags.length > 5"
      label=". . ."
      size="sm"
      type="info"
      class="mr--md">
    </dara-tag>
  </div>
</template>

<script>
import { getTagLink } from '@/modules/tag/tag.service';

export default {
  name: 'DaraArticleTags',
  props: {
    tags: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    getTagLink,
  },
};
</script>
